import { Entities, getEntities, patch } from 'src/common';
import { getOwnCompany } from 'src/selectors/bus-companies';
import { connect } from 'react-redux';
import { findOwnedByBusfinderIntegrationBusRequests } from 'src/actions/bus-requests';
import { push } from 'react-router-redux';
import { addNotification } from 'src/actions/notifications';
import BusRequestAdmin from 'src/components/admin/bus-requests/bus-request-admin';

const mapStateToProps = state => {
    return {
        busRequests: getEntities(state, Entities.BUS_REQUESTS),
        selectedCompany: state.selectedCompany,
        busCompany: getOwnCompany(state),
    };
};

const mapDispatchToProps = dispatch => {
    return {
        findOwnedByBusfinderIntegrationBusRequests: filter => {
            dispatch(findOwnedByBusfinderIntegrationBusRequests(filter));
        },
        push: (location, state) => {
            dispatch(push(location, state));
        },
        patch: (body, entity, reducerIndex) => {
            dispatch(patch(body, entity, reducerIndex));
            // dispatch(selectEvent(''));
        },
        addNotification: (title, message, level, position) => {
            dispatch(addNotification(title, message, level, position));
        },
    };
};

const BusRequestAdminContainer = connect(mapStateToProps, mapDispatchToProps)(BusRequestAdmin);
export default BusRequestAdminContainer;
